var index = {
    toast(){
        
        $(".go_title_btn").click(function(){
       
            $(".leyu_yspd,.toumingbi_yspd").show()
        })
        $(".close_ly").click(function(){
            $(".leyu_yspd,.toumingbi_yspd").hide()
        })
        $(".zixun").click(function(){
       
            $(".leyu_yspd,.toumingbi_yspd").show()
        })
        
    },
    yuyue(){
        $(".guanbi").click(function(){
            $(".form").hide()
        })
        $(".select-one .option").click(function () {
            var _this = $(this);
      
            _this.parent().prev().text(_this.text());
      
            $(".couse01").val(_this.text());
          });
          $(".select-city .option").click(function () {
            var _this = $(this);
      
            _this.parent().prev().text(_this.text());
      
            $(".city03").val(_this.text());
          });
          $('.form').listenForm({
            contentName:  [{
                search: "?jtppzq",
                name: "品宣在线报名（百品）"
              }, {
                search: "?360jtppzq",
                name: "品宣在线报名（360）"
              }, {
                search: "",
                name: "品宣在线报名"
              }],
            submitTarget: '#submitBtn2',
            courseRequired: true,
            cityRequired: true
          });
    },
    init(){
        this.toast()
        this.yuyue()
    }
}
index.init()